import { Component, Inject, ViewChild, ElementRef, AfterViewInit, PLATFORM_ID } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { isPlatformBrowser } from '@angular/common';

export interface DialogData {
  municipality_id: number,
  latitude: number,
  longitude: number,
  province_id: number,
  district_id: number,
  wardNumber: number,
  village: string,
  provinceList: Array<any>,
  municipalityList: Array<any>
  districtList: Array<any>
}

@Component({
  selector: 'app-edit-location-info',
  templateUrl: './edit-location-info.component.html',
  styleUrls: ['./edit-location-info.component.css']
})
export class EditLocationInfoComponent implements AfterViewInit{

  @ViewChild('mapContainer', {static: false}) gmap: ElementRef

  @ViewChild('location', {static: false}) location: ElementRef

  map: google.maps.Map;

  coordinates: any

  mapOptions: google.maps.MapOptions

  marker: any

  locationInfoForm: FormGroup = new FormGroup({
    municipality_id: new FormControl(null, [Validators.required]),
    latitude: new FormControl('', [Validators.required]),
    longitude: new FormControl('', [Validators.required]),
    province_id: new FormControl( null, [Validators.required]),
    district_id: new FormControl( null, [Validators.required]),
    wardNumber: new FormControl( null, [Validators.required]),
    village: new FormControl('')
  })

  property: any

  selectedUnitTotal: string

  selectedUnitHouse: string

  selectedUnitDistance: string

  provinceList = []

  districtList = []

  municipalityList = []

  validDistrictList = []

  validMunicipalityList = []

  latitude: number

  longitude: number

  autocomplete: any

  options = {
    componentRestrictions: {country: 'np'}
  };

  constructor(
    public dialogRef: MatDialogRef<EditLocationInfoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, @Inject(PLATFORM_ID) protected platformId: Object) {
      this.municipalityList = data.municipalityList
      this.districtList = data.districtList
      this.provinceList = data.provinceList
      this.validDistrictList = this.districtList
      this.validMunicipalityList = this.municipalityList
      delete data['municipalityList']
      delete data['provinceList']
      delete data['districtList']
      this.latitude = data.latitude
      this.longitude = data.longitude
      this.locationInfoForm.setValue(data)
    }

  onNoClick(): void {
    this.dialogRef.close();
  }

  savePropertyLocationInfo(){
    if(this.locationInfoForm.valid){
      let locationInfo= this.locationInfoForm.value
      locationInfo['latitude'] = this.latitude
      locationInfo['longitude'] = this.longitude
      this.dialogRef.close(locationInfo)
    }
  }

  ngAfterViewInit(){
    this.mapInitializer()
  }

  mapInitializer() {
    if(isPlatformBrowser(this.platformId)){
      this.coordinates  = new google.maps.LatLng(this.latitude, this.longitude)
      this.mapOptions = {
          center: this.coordinates,
          zoom: 14
      }
      this.marker = new google.maps.Marker({
          position: this.coordinates,
          map: this.map,
      })
      this.map = new google.maps.Map(this.gmap.nativeElement, this.mapOptions)
      this.autocomplete = new google.maps.places.Autocomplete(this.location.nativeElement, this.options);
      google.maps.event.addListener(this.autocomplete, 'place_changed', ()=>{
        var place = this.autocomplete.getPlace();
        if(this.marker === false){
          this.marker = new google.maps.Marker({
            position: place.geometry.location,
            map: this.map,
            draggable: true //make it draggable
          });
          this.map.setCenter(place.geometry.location);
        }else{
          this.marker.setPosition(place.geometry.location);
          this.map.setCenter(place.geometry.location);
        }
        this.latitude = this.marker.getPosition().lat()
        this.longitude = this.marker.getPosition().lng()
      });
      google.maps.event.addListener(this.map, 'click', (event)=> {
        var clickedLocation = event.latLng;
        if(this.marker === false){
          this.marker = new 
          google.maps.Marker({
            position: clickedLocation,
            map: this.map,
            draggable: true, //make it draggable
            title: "Your Location"
          });
          google.maps.event.addListener(this.marker, 'dragend', (event)=>{
            this.latitude = this.marker.getPosition().lat()
            this.longitude = this.marker.getPosition().lng()
          });
        }else{
          this.marker.setPosition(clickedLocation);
        }
        this.latitude = this.marker.getPosition().lat()
        this.longitude = this.marker.getPosition().lng()
      });
      google.maps.event.addListener(this.marker, 'dragend', (event) => {
        let draggedLocation = event.latLng;
        this.marker.setPosition(draggedLocation)
        this.data.latitude = this.marker.getPosition().lat()
        this.data.longitude = this.marker.getPosition().lng()
      })
      this.marker.setMap(this.map);
    }
  }

  onProvinceSelected($event){
    this.validDistrictList = []
    for(let district of this.districtList){
      if(district.province_id == $event){
        this.validDistrictList.push(district)
      }
    }
  }

  onDistrictSelected($event){
    this.validMunicipalityList = []
    for(let muncipality of this.municipalityList){
      if(muncipality.district_id == $event){
        this.validMunicipalityList.push(muncipality)
      }
    }
    let selectedDistrict = this.districtList.find(district => district.id == $event)
    if(selectedDistrict){
      this.locationInfoForm['controls']['province_id'].setValue(selectedDistrict.province_id)
    }
  }

  onMunicipalitySelected($event){
    let selectedMunicipality = this.municipalityList.find(municipality => municipality.id == $event)
    if(selectedMunicipality){
      this.locationInfoForm['controls']['district_id'].setValue(selectedMunicipality.district_id)
      let selectedDistrict = this.districtList.find(district => district.id == selectedMunicipality.district_id)
      if(selectedDistrict){
        this.locationInfoForm['controls']['province_id'].setValue(selectedDistrict.province_id)
      }
    }
  }

}